import request from '@/utils/request'

const bungieApi = process.env['VUE_APP_BUNGIE_API'] || 'https://www.bungie.net/Platform'
const bungieBase = process.env['VUE_APP_BUNGIE_BASE'] || 'https://www.bungie.net'

export function SearchDestinyPlayerByBungieName(data) {
  return request({
    url: bungieApi + `/Destiny2/SearchDestinyPlayerByBungieName/All/`,
    method: 'post',
    data
  })
}
export function GetProfile(params, membershipType, membershipId) {
  return request({
    url: bungieApi + `/Destiny2/${membershipType}/Profile/${membershipId}/`,
    method: 'get',
    params
  })
}
export function Manifest() {
  return request({
    url: bungieApi + `/Destiny2/Manifest/`,
    method: 'get'
  })
}

export function GetDefinition(url) {
  return request({
    url: bungieBase + url,
    method: 'get'
  })
}
